import React from "react";
import EditButton from "../Buttons/EditButton";
import CheckWithDateIntake from "../CheckWithDateIntake";
import EditIntakeForm from "../forms/EditIntakeForm";
import StandardDrawer from "../forms/StandardDrawer";
import { useState } from "react";
import { format } from "date-fns";

function FormLine2(props) {
  const [openEditIntakeForm, setopenEditIntakeForm] = useState(false);

  const handleOpenEditIntakeForm = (event) => {
    event?.stopPropagation?.();
    setopenEditIntakeForm(true);
  };

  const handleCloseEditIntakeForm = (event) => {
    event?.stopPropagation?.();
    setopenEditIntakeForm(false);
  };

  const handleRowKeyDown = (event) => {
    if (props.signed && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      handleOpenEditIntakeForm();
    }
  };

  function formatDate(timestamp) {
    if (!timestamp || !timestamp.seconds) return "";

    const milliseconds =
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
    const date = new Date(milliseconds);

    if (isNaN(date)) return "";

    return format(date, "d MMMM yyyy"); // "d" pour le jour, "MMMM" pour le mois en texte, "yyyy" pour l'année
  }

  function formatSignedOn(timestamp) {
    if (!timestamp || !timestamp.seconds) return "";
    const date = new Date(
      timestamp.seconds * 1000 + (timestamp.nanoseconds || 0) / 1000000
    );
    return isNaN(date) ? "" : format(date, "d MMM yyyy, HH:mm");
  }

  return (
    <div
      className={
        `${
          props.color === "1" ? "formLine light-grey-form" : "formLine grey-form"
        } ${props.signed ? "form-row-clickable" : ""}`
      }
      onClick={props.signed ? handleOpenEditIntakeForm : undefined}
      onKeyDown={handleRowKeyDown}
      role={props.signed ? "button" : undefined}
      tabIndex={props.signed ? 0 : undefined}
    >
      <StandardDrawer
        open={openEditIntakeForm}
        onClose={handleCloseEditIntakeForm}
        className="intake-form-drawer-paper"
        contentClassName="intake-form-drawer-content"
      >
        <div
          className="standard-drawer-form-wrapper"
          onClick={(event) => event.stopPropagation()}
          onKeyDown={(event) => event.stopPropagation()}
        >
          <EditIntakeForm closemodal={handleCloseEditIntakeForm} {...props} />
        </div>
      </StandardDrawer>
      <div className="formLineBlock1">{props.title}</div>
      <div className="formLineBlock2">
        <CheckWithDateIntake
          checked={props.signed ? "checked" : ""}
          content={formatDate(props.dateOfAdmission)}
          signedOnContent={formatSignedOn(props.signedOn)}
        />
      </div>
      <div className="formLineBlock3">
        {/* {props.signed === "signed" ? <ViewButton /> : ""} */}
        {props.signed === true ? (
          <EditButton handleOpen={handleOpenEditIntakeForm} />
        ) : (
          ""
        )}

        {/* <PrintButton />
        <MailButton /> */}
      </div>
    </div>
  );
}

export default FormLine2;
